<template>
  <v-navigation-drawer
    v-model="drawer"
    :clipped="$vuetify.breakpoint.lgAndUp"
    fixed
    app
    id="navbar-collapse"
    overlay="none"
    class="side-bar-scoll"
    :class="[isPopupVisible ? 'overrlay-active' : '']"
  >
    <v-list rounded v-if="isAdminLevel">
      <v-subheader class="mt-4 grey--text text--darken-1 Admin-Account Subtitle"
        >Admin Account</v-subheader
      >
      <v-list-item-group v-model="selectedMenu" color="primary">
        <v-list-item
          v-for="item in admin_account_menus"
          :key="item.text"
          :to="item.to"
          link
        >
          <v-list-item-icon>
            <v-icon :class="item.class">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="item.class2">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list v-if="$globalConfig.APP_NAME === 'direct' && isAdminLevel">
      <v-subheader class="mt-4 grey--text text--darken-1 Billing">Billing</v-subheader>
      <v-list-item-group v-model="selectedBillingMenu" color="primary">
        <v-list-item
          v-for="item in billing_menus"
          :key="item.text"
          :to="item.to"
          link
        >
          <v-list-item-action>
            <v-icon :class="item.class">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title :class="item.class2">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list rounded v-if="isManagerLevel">
      <v-subheader class="mt-4 grey--text text--darken-1 Admin-Account Subtitle"
        >My User Account</v-subheader
      >
      <v-list-item-group v-model="selectedAccountMenu" color="primary">
        <v-list-item
          v-for="item in manager_account_menus"
          :key="item.text"
          :to="item.to"
          link
        >
          <v-list-item-action>
            <v-icon :class="item.class">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title :class="item.class2">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list rounded v-if="isUserLevel || isAdminLevel">
      <v-subheader class="mt-4 grey--text text--darken-1 Admin-Account Subtitle"
        >My User Account</v-subheader
      >
      <v-list-item-group v-model="selectedAccountMenu" color="primary">
        <v-list-item
          v-for="item in user_account_menus"
          :key="item.text"
          :to="item.to"
          link
        >
          <v-list-item-action>
            <v-icon :class="item.class">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title :class="item.class2">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: 'Navigation',
  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      drawer: this.toggle,
      user: this.$store.getters.user.first_name,
      selectedMenu: null,
      selectedBillingMenu: null,
      selectedAccountMenu: null,
      items: [
        { title: 'Users', icon: 'dashboard', path: 'admin/courses' },
        { title: 'Courses', icon: 'question_answer', path: 'admin/courses' },
        { title: 'Playlists', icon: 'question_answer', path: '#' },
        { title: 'Reports', icon: 'question_answer', path: '#' },
        { title: 'Groups', icon: 'question_answer', path: '#' },
        { title: 'Marketplace', icon: 'question_answer', path: 'admin/marketplace'},
        { title: 'Help', icon: 'question_answer', path: 'admin/help' },
      ],
      admin_account_menus: [
        {
          icon: 'fas fa-book',
          text: 'Full Course Library',
          class: 'course-vector',
          class2: 'Full-Course-Library',
          to: '/admin/courses',
          index: 0,
        },
        {
          icon: 'fas fa-user-cog',
          text: 'User Management',
          class: 'user-vector',
          class2: 'User-Management',
          to: '/admin/users',
          index: 1,
        },
        {
          icon: 'fas fa-user-cog',
          text: 'Archived Users',
          class: 'user-vector',
          class2: 'User-Management',
          to: '/admin/archived-users',
          index: 2,
        },
        {
          icon: 'fas fa-users',
          text: 'Groups',
          class: 'groups-vector',
          class2: 'Groups',
          to: '/admin/groups',
          index: 3,
        },
        {
          icon: 'fas fa-list',
          text: 'Playlists',
          class: 'playlists-vector',
          class2: 'Playlists',
          to: '/admin/playlists',
          index: 4,
        },
        {
          icon: 'fas fa-chart-line',
          text: 'Reports',
          class: 'reports-vector',
          class2: 'Reports',
          to: '/admin/reports',
          index: 5,
        },
        {
          icon: 'fas fa-cog',
          text: 'Settings',
          class: 'reports-vector',
          class2: 'Reports',
          to: '/admin/settings',
          index: 6,
        },
      ],
      billing_menus: [
        {
          icon: 'fas fa-building',
          text: 'Company Information',
          class: 'company-vector',
          class2: 'Company-Information',
          to: '/admin/finance/company',
          index: 5,
        },
        {
          icon: 'fas fa-user-shield',
          text: 'Account Status',
          class: 'account-vector',
          class2: 'Account-Status',
          to: '/admin/finance/account-status',
          index: 6,
        },
      ],
      user_account_menus: [
        {
          icon: 'fas fa-address-book',
          text: 'My Courses',
          class: 'my-courses-vector',
          class2: 'My-Courses',
          to: '/courses',
        },
        {
          icon: 'fas fa-list',
          text: 'My Playlists',
          class: 'my-playlist-vector',
          class2: 'My-Playlists',
          to: '/playlists',
        },
        {
          icon: 'fas fa-external-link-square-alt',
          text: 'My External Training',
          class: 'my-external-vector',
          class2: 'My-External-Training',
          to: '/profile/external-training',
        },
        {
          icon: 'fas fa-chart-bar',
          text: 'My Progress Summary',
          class: 'my-progress-vector',
          class2: 'My-Progress-Summary',
          to: '/profile/activity',
        },
      ],
      manager_account_menus: [
       {
          icon: 'fas fa-book-sparkles',
          text: 'Course Library',
          class: 'my-course-vector',
          class2: 'Full-Course-Library',
          to: '/course-library',
        },
        {
          icon: 'fas fa-address-book',
          text: 'My Courses',
          class: 'my-courses-vector',
          class2: 'My-Courses',
          to: '/courses',
        },
        {
          icon: 'fas fa-list',
          text: 'My Playlists',
          class: 'my-playlist-vector',
          class2: 'My-Playlists',
          to: '/playlists',
        },
        {
          icon: 'fas fa-external-link-square-alt',
          text: 'My External Training',
          class: 'my-external-vector',
          class2: 'My-External-Training',
          to: '/profile/external-training',
        },
        {
          icon: 'fas fa-chart-bar',
          text: 'My Progress Summary',
          class: 'my-progress-vector',
          class2: 'My-Progress-Summary',
          to: '/profile/activity',
        },
        {
          icon: 'fas fa-users',
          text: 'My Team',
          class: 'my-progress-vector',
          class2: 'My-team',
          to: '/my-team',
        },
      ],
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    level: function () {
      const user = this.$store.getters.user;
      return user.first_name + ' ' + user.last_name;
    },
    userName: function () {
      return this.$store.getters.isLoggedIn;
    },
    showAdmin: function () {
      return this.$store.getters.admin && window.innerWidth > 1200;
    },
    isAdminLevel: function () {
      const level = this.$store.getters.level;
      if (level == 2) {
        return true;
      } else {
        return false;
      }
    },
    isUserLevel: function () {
      const level = this.$store.getters.level;
      if (level == 3) {
        return true;
      } else {
        return false;
      }
    },
    isManagerLevel: function () {
      const level = this.$store.getters.level;
      if (level == 7) {
        return true;
      } else {
        return false;
      }
    },
    isPopupVisible() {
      return this.$store.getters.bookDemo;
    }
  },
  mounted() {
    this.selectedItem();
    //this.isImproveAccess();
  },
  watch: {
    toggle(newVal) {
      this.drawer = true;
    },
  },
  methods: {
    selectedItem: function () {      
      if (this.$route.path == '/admin/courses') {
        this.selectedMenu = 0;
      } else if (this.$route.path == '/admin/users') {
        this.selectedMenu = 1;
      } else if (this.$route.path == '/admin/groups') {
        this.selectedMenu = 2;
      } else if (this.$route.path == '/admin/playlists') {
        this.selectedMenu = 3;
      } else if (this.$route.path == '/admin/reports') {
        this.selectedMenu = 4;
      } else if (this.$route.path == '/profile/company') {
        this.selectedBillingMenu = 0;
      } else if (this.$route.path == '/courses') {
        this.selectedAccountMenu = 0;
      } else if (this.$route.path == '/playlists') {
        this.selectedAccountMenu = 1;
      } else if (this.$route.path == '/profile/external-training') {
        this.selectedAccountMenu = 2;
      } else if (this.$route.path == '/profile/activity') {
        this.selectedAccountMenu = 3;
      }
      if (document.getElementById('navbar-collapse')) {
        if (screen.width <= 1262) {
          document.getElementById('navbar-collapse').style.display = 'none';
          //document.getElementsByClassName('v-overlay__scrim').remove();
        } else {
          document.getElementById('navbar-collapse').style.display = 'block';
        }
      }
    },
    isImproveAccess() {
      const isContentAdded = this.$store.getters.improveContent;
      if (isContentAdded) {
        this.admin_account_menus = [];
        this.admin_account_menus.push(
          {
            icon: 'fas fa-book',
            text: 'Full Course Library ',
            class: 'course-vector',
            class2: 'Full-Course-Library',
            to: '/admin/courses',
            index: 0,
          },
          {
            icon: 'fas fa-user-cog',
            text: 'User Management',
            class: 'user-vector',
            class2: 'User-Management',
            to: '/admin/users',
            index: 1,
          },
          {
            icon: 'fas fa-user-cog',
            text: 'Archived Users',
            class: 'user-vector',
            class2: 'User-Management',
            to: '/admin/archived-users',
            index: 2,
          },
          {
            icon: 'fas fa-users',
            text: 'Groups',
            class: 'groups-vector',
            class2: 'Groups',
            to: '/admin/groups',
            index: 3,
          },
          {
            icon: 'fas fa-list',
            text: 'Playlists',
            class: 'playlists-vector',
            class2: 'Playlists',
            to: '/admin/playlists',
            index: 4,
          },
          {
            icon: 'fas fa-chart-line',
            text: 'Reports',
            class: 'reports-vector',
            class2: 'Reports',
            to: '/admin/reports',
            index: 5,
          }
        );
      }
    },
  },
};
</script>
<style>
.v-overlay__scrim {
  opacity: 0 !important;
}
</style>
